import * as React from 'react';
import { connect } from 'react-redux';
import { CreateSurveyProps } from '../../common/CreateSurveyProps';
import getLangTranslation from '../../common/lang-trans';
import { ApplicationState } from '../../store';
import * as CreateSurveyStore from '../../store/CreateSurvey';
import SurveyEndnote from '../survey/SurveyEndnote';
import SurveyQuestionnaire from '../survey/SurveyQuestionnaire';
import SurveyStart from '../survey/SurveyStart';

class Preview extends React.Component<CreateSurveyProps> {

    private SubmitSurvey() {}
    private SetValidationStatusAndValue() {}
    private MoveNextStep() {}

    public componentDidMount() {
        this.props.SetLanguage(this.props.language || 'en', false);
    }

    render() {
        const language = this.props.language || 'en';
        const langTrans = getLangTranslation(language);


        return(
            <React.Fragment>
            <div className="row" >
                <div className="col-sm-12">
                    <div className='d-flex flex-row-reverse'>
                        <button className="btn btn-outline-primary" onClick={() => this.props.SetLanguage(langTrans.OtherLangShort, false)}>{langTrans.OtherLang}</button>
                    </div>
                </div>
            </div>
            <div className="row" >
                <div className="col-sm-12">

                    <SurveyStart
                        moveNextStep={ this.MoveNextStep }
                        survey={ this.props.survey }
                        language={ this.props.language }></SurveyStart>

<br />
<hr />
<br />
                        
                    <SurveyQuestionnaire
                        errorInSubmit={ this.props.errorInSubmit }
                        isSubmitted={ this.props.isSubmitted }
                        survey={ this.props.survey }
                        language={ this.props.language }
                        SubmitSurvey={ this.SubmitSurvey }
                        SetValidationStatus={ this.SetValidationStatusAndValue }
                        SetValidationStatusAndValue={ this.SetValidationStatusAndValue }></SurveyQuestionnaire>

<br />
<hr />
<br />
                    <SurveyEndnote
                        survey={ this.props.survey }
                                ></SurveyEndnote>
                    
                </div>

                <div className="col-sm-12 mt-5">
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(this.props.step -1 )}>Previous</button>
                    <button className="btn btn-primary" onClick={() => this.props.MoveNextStep(undefined)}>Continue</button>
                </div>

            </div>
        </React.Fragment>
        );
    }
};

export default connect(
    (state: ApplicationState) => state.createSurveyStore,
    CreateSurveyStore.actionCreators
)(Preview as any);

